export type FAQItem = {
  question: string;
  answer: string;
};

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: 'Do participants need an account?',
    answer:
      "No. Anyone with your meeting planner link can open it, enter their name, and mark when they're free — no sign‑up or email required.",
  },
  {
    question: 'What is the availability grid and how does it work?',
    answer:
      "The availability grid is where participants mark the times they're available for a meeting. It's color-coded to highlight overlapping schedules, making it easy to see which time slots work best for the most people. Participants can simply drag and drop on the availability grid to indicate when they're free.",
  },
  {
    question: 'Does it handle different time zones?',
    answer:
      'Yes. Times are displayed consistently for each person in their local time and overlaps are calculated automatically, so groups across timezones can coordinate without math.',
  },
  {
    question: 'How many people can respond to a meeting planner?',
    answer:
      'The free plan supports up to 10 participants per meeting planner, while the Premium plan supports up to 20 participants. It works great for small teams, clubs, and medium-sized groups. If you see things getting slow with very big groups, consider creating two planners by subgroup.',
  },
  {
    question: 'Can I edit my availability after submitting?',
    answer:
      'Yes. Reopen the same meeting planner link and update your blocks at any time while the planner is open.',
  },
  {
    question: 'Can others see my personal calendar events?',
    answer:
      "No. Only the availability you choose to share on the availability grid is visible to others. We don't read or upload your personal calendar.",
  },
  {
    question: 'Can I keep responses private to the organizer?',
    answer:
      'Right now, anyone with the meeting planner link can view responses.',
  },
  {
    question: 'Will I get notified when someone responds?',
    answer:
      'Email or push notifications are not available yet. For now, open your meeting planner to see new responses.',
  },
  {
    question: 'Can I send reminders to participants?',
    answer:
      'There is no built‑in emailer today. Copy the meeting planner link and send it via your preferred channel (chat, email, group text).',
  },
  {
    question: 'Can I add the selected event to my calendar?',
    answer:
      'Yes! Click the "Schedule Event" button, select a time slot on the availability grid, and then add the event to Google Calendar, Outlook Calendar, or download it as an ICS file.',
  },
];
